export default __webpack_public_path__ + "images/roya-checkpoint.svg";